// src/components/HabitoCard.js

import React from 'react';
import Card from './Card';
import Button from './Button';
import { FaCheckCircle, FaHourglassHalf, FaExclamationTriangle } from 'react-icons/fa';

// Función para obtener los días de la semana (Lunes = 0)
const getDaysOfWeek = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

    const days = [];
    for (let i = 0; i < 7; i++) {
        const day = new Date(startOfWeek);
        day.setDate(startOfWeek.getDate() + i);
        days.push(day);
    }
    return days;
};

function HabitoCard({ tarea, onCompletarHabito }) {
    const weekDays = getDaysOfWeek();
    const todayISO = new Date().toISOString().split('T')[0];
    const registroDeHoy = (tarea.registros_semana || []).find(r => r.fecha === todayISO);

    // El niño puede completar si no hay registro, o si el registro fue rechazado y no recompletado
    const puedeCompletarHoy = !registroDeHoy || (registroDeHoy.rechazado && !registroDeHoy.completado);

    return (
        <Card>
            <div className='flex justify-between items-start'>
                <h3 className="text-xl font-bold text-gray-800">{tarea.titulo}</h3>
                <div className="font-bold text-acento text-lg bg-yellow-100 rounded-full px-4 py-1">{tarea.puntos} ✨</div>
            </div>
            <p className="text-gray-600 my-4">{tarea.descripcion}</p>

            {/* Tracker Semanal */}
            <div className="my-4">
                <p className="font-bold text-center mb-2">Progreso de la Semana</p>
                <div className="flex justify-around">
                    {weekDays.map((day, index) => {
                        const dayInitial = day.toLocaleDateString('es-ES', { weekday: 'short' }).charAt(0).toUpperCase();
                        const dayISO = day.toISOString().split('T')[0];
                        const registro = (tarea.registros_semana || []).find(r => r.fecha === dayISO);

                        let statusIcon = <div className="w-8 h-8 rounded-full bg-gray-200"></div>;
                        if (registro) {
                            if (registro.aprobado) {
                                statusIcon = <FaCheckCircle className="w-8 h-8 text-green-500" title="Aprobado"/>;
                            } else if (registro.completado) {
                                statusIcon = <FaHourglassHalf className="w-8 h-8 text-yellow-500 animate-spin" title="Pendiente"/>;
                            } else if (registro.rechazado) {
                                // Muestra un ícono de error si fue rechazado y no recompletado
                                statusIcon = <FaExclamationTriangle className="w-8 h-8 text-red-500" title="Rechazado"/>;
                            }
                        }
                        
                        return (
                            <div key={index} className="flex flex-col items-center gap-1">
                                <span className={`font-bold ${dayISO === todayISO ? 'text-principal' : 'text-gray-400'}`}>{dayInitial}</span>
                                {statusIcon}
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Mostramos el comentario del padre si el hábito de hoy fue rechazado */}
            {registroDeHoy && registroDeHoy.rechazado && registroDeHoy.comentario_padre && (
                 <div className="mt-4 p-3 bg-red-200 text-red-800 rounded-lg text-sm">
                    <p className="font-bold flex items-center gap-2"><FaExclamationTriangle /> ¡A revisar este hábito!</p>
                    <p className="italic mt-1">"{registroDeHoy.comentario_padre}"</p>
                </div>
            )}
            
            <div className="flex justify-center items-center mt-4 pt-4 border-t-2 border-dashed">
                <Button onClick={() => onCompletarHabito(tarea.id)} disabled={!puedeCompletarHoy}>
                    {
                      !registroDeHoy || !registroDeHoy.completado ?
                      (registroDeHoy?.rechazado ? "¡Corregido!" : "¡Lo hice hoy!") :
                      "Ya completado hoy"
                    }
                </Button>
            </div>
        </Card>
    );
}

export default HabitoCard;